import {
  createRouter,
  createRoute,
  createRootRoute,
} from "@tanstack/react-router";
import { App } from "./App";
import HomePage from "./pages/home";
import BusinessDetails from "./pages/business-details-page";
import NotFound from "./pages/not-found";
import ErrorPage from "./pages/error-page";

// Only scroll to top when entering a new route. Using "cause" prevents
// scrolling on search param changes (e.g. pagination) within the same route.
const scrollToTop = ({ cause }: { cause: string }) => {
  if (cause === "enter") {
    window.scrollTo({ top: 0, behavior: "instant" });
  }
};

const rootRoute = createRootRoute({
  component: App,
  notFoundComponent: NotFound,
  errorComponent: ({ error, reset }) => (
    <ErrorPage error={error} reset={reset} />
  ),
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: HomePage,
  validateSearch: (
    search: Record<string, unknown>,
  ): {
    search?: string;
    address?: string;
    distance?: string;
    page?: number;
  } => ({
    ...(search.search ? { search: search.search as string } : {}),
    ...(search.address ? { address: search.address as string } : {}),
    ...(search.distance ? { distance: search.distance as string } : {}),
    ...(search.page && Number(search.page) > 1
      ? { page: Number(search.page) }
      : {}),
  }),
  beforeLoad: scrollToTop,
});

const businessRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/business/$id",
  component: BusinessDetails,
  beforeLoad: scrollToTop,
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  businessRoute,
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
